import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { Form, Formik } from 'formik';
import HTTPMethod from 'http-method-enum';
import { useYoForm } from '@yoweb/ui/hooks/forms';
import useReCaptcha from '@store/hooks/useReCaptcha';
import { ErrorDisplay, useError, Select, Input, Textarea } from '@yoweb/ui/components/form';
import { useTranslation, Trans } from '@yoweb/next-i18next';
import { Container } from '@yoweb/ui/components/containers';
import { Title, Text } from '@yoweb/ui/components/typography';
import { BodyLink } from '@yoweb/ui/lib/components/marketing/MarketingTexts';
import { Box } from '@yoweb/ui/components/Box';
import { Spacer } from '@yoweb/ui/components/Spacer';
import { Button } from '@yoweb/ui/components/buttons';
import { getSpace, getColor, getRadii } from '@yoweb/ui/lib/styles/utils/theme';
import { media, pxToRem, gridBase } from '@yoweb/ui/lib/styles/utils';
import getInTouchForm, { getNumEmployeesOptions, getYourRoleOptions, getIndustryOptions, getHowDidYouHearAboutUsOptions, getYourRoleOptionsV2Japan } from '@store/components/Employers/getInTouchForm';
import AnimateIn, { DURATIONS, InView, StaggerElements } from '@yoweb/ui/components/AnimateIn';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { API_EMPLOYERS_FORM_SUBMISSION, PAGE_PRIVACY_POLICY, API_EMPLOYERS_WHITE_PAPER_DOWNLOAD } from '@store/constants/routes';
import { ACTION_EMPLOYERS_FORM_SUBMISSION } from '@store/constants/recaptcha';
import { formatPhone } from '@store/utils/formatPhone';
import NameGrid from '@yoweb/ui/components/NameGrid';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var fieldSetRowGapWidth = pxToRem(18);
export var EmployersForm = function EmployersForm() {
  var _useState = useState(false),
      success = _useState[0],
      setSuccess = _useState[1];

  var _useTranslation = useTranslation(['common', 'employers-form']),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var reCaptcha = useReCaptcha();
  var errorDisplay = useError();

  var _useIntlMeta = useIntlMeta(),
      lcLocale = _useIntlMeta.lcLocale,
      country = _useIntlMeta.country;

  var yoForm = useYoForm('common', getInTouchForm);
  var numEmployeesOptions = getNumEmployeesOptions(t);
  var yourRoleOptions = getYourRoleOptions(t, lcLocale);
  var industryOptions = getIndustryOptions(t);
  var howDidYouHearAboutUsOptions = getHowDidYouHearAboutUsOptions(t);
  var showError = Boolean(errorDisplay.message);
  var bgColor = 'gingko';
  useEffect(function () {
    if (success) {
      var _document$querySelect;

      (_document$querySelect = document.querySelector('#get-in-touch-section')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [success]);

  var handleOnSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, actions) {
      var _yield$formatPhone, isValid, phoneNumber, reCaptchaToken;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              errorDisplay.clear();

              if (!values.phoneNum) {
                _context.next = 12;
                break;
              }

              _context.next = 5;
              return formatPhone({
                phoneNumber: values.phoneNum,
                countryCode: country
              });

            case 5:
              _yield$formatPhone = _context.sent;
              isValid = _yield$formatPhone.isValid;
              phoneNumber = _yield$formatPhone.phoneNumber;

              if (isValid) {
                _context.next = 11;
                break;
              }

              actions.setErrors({
                phoneNum: t('employers-form:form.phone-invalid')
              });
              return _context.abrupt("return");

            case 11:
              actions.setFieldValue('phoneNum', phoneNumber);

            case 12:
              _context.next = 14;
              return reCaptcha.execute(ACTION_EMPLOYERS_FORM_SUBMISSION);

            case 14:
              reCaptchaToken = _context.sent;
              _context.next = 17;
              return fetchJson(API_EMPLOYERS_FORM_SUBMISSION, {
                method: HTTPMethod.POST,
                body: JSON.stringify(_objectSpread(_objectSpread({}, values), {}, {
                  locale: i18n.language,
                  reCaptchaToken: reCaptchaToken
                }))
              });

            case 17:
              setSuccess(true);
              _context.next = 25;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](0);
              errorDisplay.set({
                title: t('common:error.title'),
                message: t('common:error.description')
              });
              actions.setSubmitting(false);
              throw _context.t0;

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 20]]);
    }));

    return function handleOnSubmit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var isJapanLocale = lcLocale === 'ja-jp';
  var lastNameSpecs = {
    id: 'lastName',
    name: 'lastName',
    label: t('employers-form:labels.lastName')
  };
  var firstNameSpecs = {
    id: 'firstName',
    name: 'firstName',
    label: t('employers-form:labels.firstName')
  };

  var showField = function showField(fields, key) {
    return fields.includes(key);
  };

  return /*#__PURE__*/_jsx(InView, {
    children: function children(isInView) {
      return /*#__PURE__*/_jsx(AnimateIn, {
        isVisible: isInView,
        config: {
          opacity: {
            animate: true,
            duration: DURATIONS.d67
          },
          y: {
            animate: false,
            offset: 0
          }
        },
        children: /*#__PURE__*/_jsx(GetInTouchWrapper, {
          bgColor: bgColor,
          id: "get-in-touch-section",
          children: /*#__PURE__*/_jsx(StaggerElements, {
            isInView: isInView,
            children: /*#__PURE__*/_jsxs(GetInTouchGrid, {
              children: [/*#__PURE__*/_jsxs(GetInTouchText, {
                children: [/*#__PURE__*/_jsx(Title, {
                  size: {
                    _: 'md',
                    md: 'xl'
                  },
                  "data-testid": "get-in-touch-title",
                  whiteSpace: "pre-wrap",
                  children: t('employers-form:titlev2')
                }), /*#__PURE__*/_jsx(Title, {
                  as: "p",
                  size: {
                    _: 'xs',
                    md: 'sm'
                  },
                  weight: "regular",
                  variant: {
                    _: 'primary',
                    lg: 'muted'
                  },
                  "data-testid": "get-in-touch-subtitle",
                  children: t('employers-form:subtitlev2')
                })]
              }), /*#__PURE__*/_jsxs(FormSection, {
                children: [success && /*#__PURE__*/_jsx(SuccessContainerWrapper, {
                  children: /*#__PURE__*/_jsxs(SuccessContainer, {
                    "data-testid": "success-container",
                    children: [/*#__PURE__*/_jsx(Title, {
                      size: "sm",
                      children: t('employers-form:success.titlev2')
                    }), /*#__PURE__*/_jsx(Text, {
                      size: "lg",
                      variant: "muted",
                      children: t('employers-form:success.subtitlev2')
                    }), isJapanLocale && /*#__PURE__*/_jsx(Box, {
                      mt: 'normal1',
                      children: /*#__PURE__*/_jsx(Button, {
                        "data-testid": "download-submit",
                        as: "a",
                        variant: "primary",
                        href: "".concat(API_EMPLOYERS_WHITE_PAPER_DOWNLOAD, "?locale=").concat(i18n.language),
                        children: t('employers-form:white-paper.button.download')
                      })
                    })]
                  })
                }), /*#__PURE__*/_jsxs(FormContainer, {
                  $isVisible: !success,
                  children: [showError && /*#__PURE__*/_jsx(Box, {
                    mb: "normal2",
                    children: /*#__PURE__*/_jsx(ErrorDisplay, _objectSpread(_objectSpread({
                      withBorder: true
                    }, errorDisplay), {}, {
                      "data-testid": "error"
                    }))
                  }), /*#__PURE__*/_jsx(Formik, {
                    initialValues: yoForm.initialState,
                    validationSchema: yoForm.schema,
                    onSubmit: handleOnSubmit,
                    children: function children(_ref2) {
                      var isSubmitting = _ref2.isSubmitting,
                          isValid = _ref2.isValid,
                          dirty = _ref2.dirty;
                      return /*#__PURE__*/_jsxs(Form, {
                        children: [/*#__PURE__*/_jsxs(Fieldset, {
                          children: [/*#__PURE__*/_jsx(Title, {
                            size: "xs",
                            weight: "bold",
                            "data-testid": "form-title",
                            children: t('employers-form:form-titlev2')
                          }), /*#__PURE__*/_jsxs(NameGrid, {
                            needsPronunciationFields: false,
                            rowGapWidth: fieldSetRowGapWidth,
                            children: [/*#__PURE__*/_jsx(Input, _objectSpread({}, firstNameSpecs)), /*#__PURE__*/_jsx(Input, _objectSpread({}, lastNameSpecs))]
                          }), /*#__PURE__*/_jsx(Input, {
                            id: "companyName",
                            name: "companyName",
                            label: t('employers-form:labels.company')
                          }), showField(Object.keys(yoForm.schema.fields), 'industry') && /*#__PURE__*/_jsx(Select, {
                            id: "industry",
                            name: "industry",
                            label: t('employers-form:labels.industry'),
                            options: industryOptions,
                            "data-testid": "industry"
                          }), showField(Object.keys(yoForm.schema.fields), 'employees') && /*#__PURE__*/_jsx(Select, {
                            id: "employees",
                            name: "employees",
                            label: t('employers-form:labels.num-employees'),
                            options: numEmployeesOptions,
                            "data-testid": "numEmployees"
                          }), showField(Object.keys(yoForm.schema.fields), 'department') && /*#__PURE__*/_jsx(Input, {
                            id: "department",
                            name: "department",
                            label: t('employers-form:labels.department')
                          }), showField(Object.keys(yoForm.schema.fields), 'yourRole') && /*#__PURE__*/_jsx(Select, {
                            id: "yourRole",
                            name: "yourRole",
                            label: t('employers-form:labels.your-rolev2'),
                            options: isJapanLocale ? getYourRoleOptionsV2Japan(t) : yourRoleOptions,
                            "data-testid": "yourRole"
                          }), !isJapanLocale && showField(Object.keys(yoForm.schema.fields), 'phoneNum') && /*#__PURE__*/_jsx(Input, {
                            id: "phoneNum",
                            name: "phoneNum",
                            type: "tel",
                            label: t('employers-form:labels.phone'),
                            enforceCharacterWidth: "half"
                          }), /*#__PURE__*/_jsx(Input, {
                            id: "email",
                            name: "email",
                            type: "email",
                            label: t('employers-form:labels.email')
                          }), showField(Object.keys(yoForm.schema.fields), 'howDidYouHearAboutUs') && /*#__PURE__*/_jsx(Select, {
                            id: "howDidYouHearAboutUs",
                            name: "howDidYouHearAboutUs",
                            label: t('employers-form:labels.how-did-you-hear-about-us'),
                            options: howDidYouHearAboutUsOptions,
                            "data-testid": "howDidYouHearAboutUs"
                          }), isJapanLocale && showField(Object.keys(yoForm.schema.fields), 'phoneNum') && /*#__PURE__*/_jsx(Input, {
                            id: "phoneNum",
                            name: "phoneNum",
                            type: "tel",
                            label: t('employers-form:labels.phone'),
                            enforceCharacterWidth: "half"
                          }), /*#__PURE__*/_jsx(Textarea, {
                            id: "howCanWeHelp",
                            name: "howCanWeHelp",
                            label: t('employers-form:labels.textArea')
                          })]
                        }), /*#__PURE__*/_jsx(Spacer, {
                          size: "normal3"
                        }), /*#__PURE__*/_jsx(FullWidth, {
                          children: /*#__PURE__*/_jsx(Button, {
                            size: "lg",
                            type: "submit",
                            "data-testid": "form-submit",
                            isLoading: isSubmitting,
                            isDisabled: !(isValid && dirty),
                            children: t('employers-form:submit')
                          })
                        }), /*#__PURE__*/_jsx(Spacer, {
                          size: "normal2"
                        }), /*#__PURE__*/_jsx(Text, {
                          size: "sm",
                          variant: "muted2",
                          textAlign: "center",
                          "data-testid": "form-small-print",
                          whiteSpace: "pre-wrap",
                          children: /*#__PURE__*/_jsx(Trans, {
                            t: t,
                            i18nKey: "employers-form:small-print",
                            components: [/*#__PURE__*/_jsx(BodyLink, {
                              size: "sm",
                              variant: "muted2",
                              href: PAGE_PRIVACY_POLICY
                            }, 0)]
                          })
                        })]
                      });
                    }
                  })]
                })]
              })]
            })
          })
        })
      });
    }
  });
};
var GetInTouchWrapper = styled.div.withConfig({
  componentId: "sc-f9czak-0"
})(["width:100%;background-color:", ";padding-top:", ";padding-bottom:calc(", " + ", ");margin-top:", ";margin-bottom:-", ";", ""], function (_ref3) {
  var bgColor = _ref3.bgColor;
  return getColor(bgColor);
}, getSpace('xl1'), getSpace('large2'), getSpace('normal2'), getSpace('normal3'), pxToRem(20), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    padding-top: ", ";\n    padding-bottom: calc(", " + ", ");\n  "])), getSpace('normal4'), getSpace('medium3'), getSpace('xl2'), getSpace('normal2')));
var GetInTouchGrid = styled(Container).withConfig({
  componentId: "sc-f9czak-1"
})(["&&{", " ", "}"], gridBase, media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      grid-row-gap: ", ";\n    "])), getSpace('normal2')));
var GetInTouchText = styled.div.withConfig({
  componentId: "sc-f9czak-2"
})(["align-content:center;grid-column:1/5;grid-row:1/2;display:grid;grid-gap:", ";", " ", ""], getSpace('normal2'), media.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-column: 2/8;\n  "]))), media.lg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    grid-column: 1/6;\n  "]))));
var FormSection = styled.div.withConfig({
  componentId: "sc-f9czak-3"
})(["position:relative;display:grid;grid-row:2/3;grid-column:1/5;", " ", ""], media.md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    grid-row: 2/3;\n    grid-column: 2/8;\n  "]))), media.lg(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    grid-row: 1/2;\n    grid-column: 7/12;\n  "]))));
var FormContainer = styled.div.withConfig({
  componentId: "sc-f9czak-4"
})(["display:", ";background-color:", ";border-radius:", ";padding:", " ", " ", ";margin-top:", ";width:100%;", ""], function (_ref4) {
  var $isVisible = _ref4.$isVisible;
  return $isVisible ? 'block' : 'none';
}, getColor('base000'), getRadii('medium'), getSpace('normal4'), getSpace('normal2'), getSpace('normal4'), getSpace('normal4'), media.md(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    margin-top: unset;\n    padding: ", " ", " ", ";\n  "])), getSpace('medium1'), getSpace('normal4'), getSpace('normal4')));
var Fieldset = styled.div.withConfig({
  componentId: "sc-f9czak-5"
})(["display:grid;row-gap:", ";"], fieldSetRowGapWidth);
var FullWidth = styled.div.withConfig({
  componentId: "sc-f9czak-6"
})(["display:grid;"]);
var SuccessContainerWrapper = styled.div.withConfig({
  componentId: "sc-f9czak-7"
})(["inset:0;display:grid;align-items:center;margin-top:", ";", ""], getSpace('normal4'), media.md(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    margin-top: 0;\n    position: absolute;\n  "]))));
var SuccessContainer = styled.div.withConfig({
  componentId: "sc-f9czak-8"
})(["", ";background-color:", ";border-radius:", ";padding:", " ", ";display:grid;grid-gap:", ";"], getSpace('normal3'), getColor('base000'), getRadii('medium'), getSpace('normal2'), getSpace('normal2'), getSpace('small3'));